import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import * as Yup from "yup";
import Sidebar from "./Sidebar";
import MainContainer from "./MainContainer";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { DialogCloseIcon } from "../../../../assets";

import { yupResolver } from "@hookform/resolvers/yup";
import { EMPTY_STRING, featuresTabs } from "../../../../constants";

const validationSchema = Yup.object().shape({
  amenity: Yup.object().shape({
    // flooringTypeId: Yup.number().required("Flooring Type is required"),
    // electricityBackupId: Yup.number().required(
    //   "Electricity Backup is required"
    // ),
    // builtInYear: Yup.string().required("Build In Year is required"),
    // parkingSpace: Yup.number().required("Parking Space is required"),
    // floors: Yup.number().required("Floors is required"),
    // propertyViewId: Yup.number().required("Property View is required"),
    // featureIds: Yup.array()
    //   .of(Yup.number())
    //   .min(1, "At least one feature is required")
    //   .required("Features are required"),
    // otherRooms: Yup.string().required("Other Rooms is required"),
    // staffQuarters: Yup.string().required("Staff Quarters is required"),
    // kitchens: Yup.string().required("Kitchens is required"),
    // storeRooms: Yup.string().required("Store rooms is required"),
    // roomsIds: Yup.array()
    //   .of(Yup.number())
    //   .min(1, "At least one room is required")
    //   .required("Rooms are required"),
    // facilitesIds: Yup.array()
    //   .of(Yup.number())
    //   .min(1, "At least one facility is required")
    //   .required("Facilities are required"),
    nearbyLocations: Yup.array().of(
      Yup.object().shape({
        type: Yup.number().required(),
        name: Yup.string()
          .trim()
          .min(1, "Name should contain atleast 1 character")
          .max(200, "Name must not exceed 200 characters")
          .required("Location name is required"),
        distance: Yup.number()
          .required("Location distance is required")
          .min(0, "Distance cannot be negative"),
      })
    ),
  }),
});

const FeaturesModal = ({ show, onClose }) => {
  const [erroredFeatures, setErroredFeatures] = useState([]);
  const [selectedFeature, setSelectedFeature] = useState(1);
  const { setValue, getValues } = useFormContext();
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });
  const {
    formState: { errors },
  } = methods;

  const changeSelectedFeature = (id) => {
    setSelectedFeature(id);
  };

  const handleSubmit = (data) => {
    let tempData = data;
    setValue("nearbyLocations", tempData.amenity.nearbyLocations);
    delete tempData.amenity.nearbyLocations;
    setValue("amenity", {
      ...(getValues("amenity") ?? {}),
      ...data.amenity,
    });

    onClose();
  };

  useEffect(() => {
    if (show) {
      methods.reset({
        amenity: {
          ...getValues("amenity"),
          nearbyLocations: getValues("nearbyLocations") ?? [],
        },
      });
    } else {
      setSelectedFeature(1);
    }
    // eslint-disable-next-line
  }, [show]);

  useEffect(() => {
    const errorKeys = Object.keys(errors?.amenity || {});

    const featureGroups = [
      {
        keys: [
          "builtInYear",
          "electricityBackup",
          "parkingSpace",
          "propertyView",
          "flooringType",
          "featureIds",
        ],
        featureId: 1,
      },
      {
        keys: [
          "otherRooms",
          "staffQuarters",
          "kitchens",
          "storeRooms",
          "floors",
          "roomsIds",
        ],
        featureId: 2,
      },
      {
        keys: ["facilitesIds"],
        featureId: 3,
      },
      {
        keys: ["nearbyLocations"],
        featureId: 4,
      },
    ];

    const newFeatures = featureGroups.reduce((acc, { keys, featureId }) => {
      if (keys.some((key) => errorKeys.includes(key))) {
        acc.push(featureId);
      }
      return acc;
    }, []);

    setErroredFeatures(newFeatures);

    // eslint-disable-next-line
  }, [errors]);

  return (
    <Modal show={show} dialogClassName="features-modal position-relative">
      <Modal.Body className="d-block d-md-flex">
        <img
          src={DialogCloseIcon}
          className="position-absolute modal-close-icon pointer"
          onClick={onClose}
          alt={EMPTY_STRING}
        />
        <Sidebar
          features={featuresTabs}
          selected={selectedFeature}
          changeSelectedFeature={changeSelectedFeature}
          erroredFeatures={erroredFeatures}
        />
        <FormProvider {...methods}>
          <MainContainer
            selectedFeature={selectedFeature}
            onSubmit={handleSubmit}
          />
        </FormProvider>
      </Modal.Body>
    </Modal>
  );
};

export default FeaturesModal;
